
<template>
    <div class="yixiaofu-charge-wrap">
        <div class="main-form">
            <div class="form-title">提取卡密</div>
            <div class="detail">
                <div class="title">
                    <div class="t0">{{name}}</div>
                    <div class="t1"></div>
                </div>
                <div class="phone-wrap" @click="showPhoneSelector" v-if="phone.id != 0">
                    <a href="javascript:;">更换</a>
                    <div class="phone">手机号码：{{phone.phone}}</div>
                </div>
                <div class="phone-wrap" @click="showPhoneSelector" v-else>
                    <a href="javascript:;">添加手机号码</a>
                    <div class="phone">手机号码：无</div>
                </div>
            </div>
            <div class="actions">
                <a href="javascript:;" @click="doSubmit" v-if="status == 0">确定提卡</a>
                <a href="javascript:;" class="disable" v-else>无法提卡</a>
            </div>
        </div>

        <div class="note">
            <h1 title="提卡说明"></h1>
            <p>1. 该加油卡只能通过积分兑换，且兑换后不可退换。</p>
            <p>2. 该加油卡请在有效期内使用，逾期作废的商城不承担任何责任。  </p>
            <p>3. 提卡需要绑定手机号码，建议使用本人手机号码，如乱填、错填手机号码导致提卡问题，商城概不处理。</p>
            <p>4. 首次提卡成功后，会收到短信提醒，如遇运营商系统忙或手机已欠费停机没有短信通知。</p>
            <p>5. 使用加油卡时请仔细核对要充值的加油卡号码，如乱填、错填加油卡号码导致的损失，商城概不处理。</p>
        </div>

        <div class="phone-dialog" :class="{'show':ui.showPhoneSelector}">
            <div class="phone-dialog-title">
                <span>选择手机号码</span>
                <a href="javascript:;" class="close-btn" @click="closePhoneSelector"></a>
            </div>
            <PhoneSelector :id="phone.id" @change="onPhoneChange" v-if="ui.showPhoneSelector"></PhoneSelector>
        </div>

        <div class="succ-dialog" :class="{'show':ui.showSucc}">
            <div class="title">
                <Icon :img="require('../../assets/icon-dialog-success.png')" class="status-icon" />
                <div class="text">提卡成功</div>
            </div>
            <div class="content">
                <div class="title">{{name}}</div>
                <!-- <div class="field">卡密平台：{{platform}}</div> -->
                <div class="field">卡号：{{cardno}}</div>
                <div class="field">手机号码：{{phone.phone}}</div>
                <div class="field">状态：已提卡</div>
                <div class="field">提卡时间：{{rechargeTime}}</div>
            </div>
            <div class="actions">
                <a href="javascript:;" @click="goWallet">回到卡包</a>
            </div>
        </div>
    </div>
</template>

<script>
import ActionButton from "@/components/products/form/ActionButton";
import PhoneSelector from "@/components/common/PhoneSelector";
import api from "../../api";

export default {
  title: "提取卡密",
  bodyClass: "gray-bg",
  components: {
    ActionButton,
    PhoneSelector
  },
  data() {
    return {
      ui: {
        showPhoneSelector: false,
        showSucc: false
      },
      gainId: this.$route.query.gainId,
      name: "",
      cardno: "", //卡号
      platform: "易小付", //卡密平台
      rechargeTime: "", //提卡时间
      status: 0,
      phone: {
        id: 0,
        phone: ""
      }
    };
  },
  methods: {
    loadData() {
      this.$showLoading("加载中");
      api.product.yixiaofuQueryCharge(
        this.gainId,
        rr => {
          console.log(rr);

          this.name = rr.name;

          if(rr.applied){
            this.status = 1;
            // this.$toast(`此卡已提卡`);
            this.ui.showSucc = true;
            this.cardno = rr.cardno;
            this.phone.phone = rr.phone;
            this.rechargeTime = rr.chargeTime;
            this.$hideLoading();
            return;
          }

          

          api.user.userPhoneAddressDefault(
            r => {
              console.log(r);
              if (r.phone) {
                this.phone.id = r.phone.id;
                this.phone.phone = r.phone.phone;
              }

              this.$hideLoading();
            },
            r => {
              console.log(r);
              this.$hideLoading();
              this.$toast(r.msg);
            }
          );
        },
        rr => {
          console.log(rr);
          this.$hideLoading();
          this.$toast(rr.msg);
        }
      );
    },
    showPhoneSelector() {
      this.ui.showPhoneSelector = true;
    },
    closePhoneSelector() {
      this.ui.showPhoneSelector = false;
    },
    onPhoneChange(phoneItem) {
      console.log(phoneItem);
      this.phone.id = phoneItem.id;
      this.phone.phone = phoneItem.phone;
      this.closePhoneSelector();
    },
    doSubmit() {
      if (this.phone.id == 0) {
        this.$toast("请选择提卡的手机号码");
        return;
      }

      this.$confirmDialog("确定提卡？", btn => {
        if (btn == "确定") {
          this.$showLoading("提卡中");
          api.product.yixiaofuCharge(
            this.gainId,
            this.phone.id,
            r => {
              console.log(r);
              this.$hideLoading();
              this.ui.showSucc = true;
              this.cardno = r.cardno;
              this.platform = r.platform;
              this.rechargeTime = r.rechargeTime;
            },
            r => {
              console.log(r);
              this.$hideLoading();
              this.$toast(r.msg);
            }
          );
        }
      });
    },
    goWallet() {
      this.$routerReplace(this, "/pages/orders/Wallet");
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style lang="less" scoped>
.yixiaofu-charge-wrap {
  .main-form {
    background: white;
    .form-title {
      font-size: 4vw;
      line-height: 16.27vw;
      padding-left: 4.53vw;
    }

    .detail {
      border: 1px solid #e6e6e6;
      border-radius: 1.33vw;
      width: 93.87vw;
      margin: 0 auto;
      padding: 2.67vw 0 3.47vw;
      box-shadow: 5px 5px 6px #e6e6e6;

      .title {
        width: 87.33vw;
        margin: 0 auto;
        border-bottom: 1px solid #e6e6e6;
        padding-left: 3.2vw;
        line-height: 2em;
        padding-bottom: 10.13vw;
        text-align: left;

        .t0 {
          color: #303030;
          font-size: 4vw;
        }

        .t1 {
          color: #5c5c5c;
          font-size: 2.93vw;
        }
      }

      .phone-wrap {
        padding-top: 3.47vw;
        a {
          display: inline-block;
          float: right;
          color: #f90b2b;
          border: 1px solid #f90b2b;
          border-radius: 3.74vw;
          font-size: 3.33vw;
          line-height: 3.74vw * 2;
          text-align: center;
          min-width: 16.27vw;
          margin-right: 2.4vw;
          padding: 0 4.8vw;
        }

        .phone {
          font-size: 4vw;
          color: #565656;
          line-height: 3.74vw * 2;
          margin-left: 5.87vw;
        }
      }
    }

    .actions {
      padding-top: 9.87vw;
      padding-bottom: 15.73vw;

      a {
        background-image: linear-gradient(to right, #ff0d33, #ff7f5f);
        color: #fff;
        height: 12vw;
        width: 92vw;
        line-height: 12vw;
        font-size: 4.26vw;
        border: none;
        display: block;
        margin: 2.53vw auto;
        border-radius: 6vw;
        text-align: center;

        &.disable {
          background-image: linear-gradient(to right, #999, #aaa);
        }
      }
    }
  }

  .note {
    width: 85.33vw;
    margin: 0 auto;
    h1 {
      line-height: 16.8vw;
      font-size: 3.73vw;
      text-align: center;
      position: relative;
      z-index: 2;

      &:before {
        content: attr(title);
        display: inline-block;
        position: relative;
        z-index: 3;
        background: #f3f1f2;
        padding: 0 6.4vw;
      }

      &:after {
        content: " ";
        display: block;
        border-bottom: 1px solid #e6e4e5;
        position: absolute;
        z-index: 1;
        width: 85.33vw;
        height: 0;
        left: 0;
        top: 50%;
      }
    }

    p {
      margin: 0;
      padding: 0;
      color: #565656;
      font-size: 2.67vw;
      line-height: 2em;
    }
  }
}

.phone-dialog {
  position: fixed;
  z-index: 10;
  top: 110vh;
  left: 0;
  right: 0;
  height: 100vh;
  background: #fff;
  transition: all 0.3s ease;

  &.show {
    top: 0;
  }
  .phone-dialog-title {
    font-size: 4.4vw;
    color: #3d3d3d;
    text-align: center;
    line-height: 13.6vw;
    border-bottom: 1px solid #d3d3d3;
    .close-btn {
      display: inline-block;
      background-image: url(../../assets/icon-address-close.png);
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      width: 2.67vw;
      height: 2.67vw;
      position: absolute;
      top: (13.6vw - 2.67vw) / 2;
      right: 4.67vw;
    }
  }
}

.succ-dialog {
  position: fixed;
  z-index: 10;
  top: 110vh;
  left: 0;
  right: 0;
  height: 100vh;
  background: #f3f1f2;
  transition: all 0.3s ease;

  &.show {
    top: 0;
  }

  .title {
    .status-icon {
      width: 16.8vw;
      height: 16.8vw;
      display: block;
      margin: 8.53vw auto 3.73vw;
    }

    .text {
      font-size: 4.27vw;
      line-height: 1em;
      text-align: center;
      color: #313131;
    }
  }

  .content {
    width: 93.87vw;
    margin: 10vw auto;
    border: 1px solid #e7e7e7;
    border-radius: 1.87vw;
    padding: 4.53vw 6.13vw;
    box-shadow: 5px 5px 6px #e7e7e7;
    background: #fff;
    box-sizing: border-box;
    .title {
      font-size: 4vw;
      color: #313131;
      line-height: 1em;
      margin-bottom: 5.07vw;
    }

    .field {
      font-size: 3.2vw;
      color: #646464;
      line-height: 5.6vw;
    }
  }

  .actions {
    padding-top: 9.87vw;
    padding-bottom: 15.73vw;

    a {
      background-image: linear-gradient(to right, #ff0d33, #ff7f5f);
      color: #fff;
      height: 12vw;
      width: 92vw;
      line-height: 12vw;
      font-size: 4.26vw;
      border: none;
      display: block;
      margin: 2.53vw auto;
      border-radius: 6vw;
      text-align: center;

      &.disable {
        background-image: linear-gradient(to right, #999, #aaa);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/orders/YixiaofuCharge.vue